module.exports = __webpack_public_path__ + "static/media/coins.03385bd7.png";